<template>
  <div class="marketplace_registration_header" id="applicationsHeader">
    <div class="header_bg_wrapper desktop_img">
      <div class="header_bg_text">
        Vivense'de Satış Noktası Olun, İşinizi Hızla Büyütün
      </div>
    </div>
    <div class="header_bg_wrapper mobile_img" style="display: none">
      <div class="header_bg_text">
        Vivense'de Satış Noktası Olun, İşinizi Hızla Büyütün
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationsSellerHeader',
};
</script>
